export default {
      id: "i-advantage1-usage",
      viewBox: "0 0 50 25",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantage1",
      toString: function () {
        return this.url;
      }
    }